import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/api/client";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [msg, setMsg] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr(""); setMsg(""); setBusy(true);
        try {
            const { data } = await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
            setMsg(data.message || "If an account exists, a reset link has been sent.");
        } catch (e) {
            setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen bg-stone-50 flex items-center justify-center p-6" data-testid="forgot-page">
            <div className="w-full max-w-md">
                <div className="relative bg-white border border-stone-200 rounded-[10px] overflow-hidden p-8 md:p-10">
                    <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-amber-500" />
                    <h2 className="text-2xl font-heading font-semibold text-stone-900 mb-1">Forgot password</h2>
                    <p className="text-sm text-stone-500 mb-6">Enter your email — we&apos;ll send a reset link.</p>
                    <form onSubmit={submit} className="space-y-4">
                        <input
                            data-testid="forgot-email"
                            type="email" required value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full border border-stone-300 rounded-md text-sm py-2.5 px-3 focus:outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500"
                            placeholder="you@exprivia.com"
                        />
                        {msg && <div data-testid="forgot-msg" className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-md px-3 py-2">{msg}</div>}
                        {err && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">{err}</div>}
                        <button data-testid="forgot-submit" disabled={busy}
                                className="w-full bg-amber-500 hover:bg-amber-600 text-white rounded-md py-2.5 font-medium">
                            Send reset link
                        </button>
                    </form>
                    <div className="mt-6 text-center">
                        <Link to="/login" className="text-sm text-amber-700 hover:text-amber-900">Back to log in</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
